import app from 'app';
import ready from 'utils/ready';

import accordion from '../components/accordion';
import freeShippingInfo from './product/free-shipping-info';
import product from './product/main';
import productGallery from './product/gallery';
import productRecommendations from './product/recommendations';
import shippingInfo from './product/shipping-info';

app.add({
  accordion,
  freeShippingInfo,
  product,
  productGallery,
  productRecommendations,
  shippingInfo,
});

ready(app.mount);
